import { type ButtonSize } from './types.js';
import { type IconSvgProps } from '@contra/icons/icons';
import { type ComponentType } from 'react';
import { css, styled } from 'styled-components';

type ButtonIconProps = {
  readonly children: ComponentType<IconSvgProps>;
  readonly size: ButtonSize;
};

const getIconSize = (size: ButtonSize): number => {
  switch (size) {
    case 'small': {
      return 20;
    }

    case 'xsmall': {
      return 16;
    }

    case 'large':
    case 'medium':
    default: {
      return 24;
    }
  }
};

const IconContainer = styled.span<{
  $iconSize: string;
}>`
  ${({ $iconSize }) => css`
    height: ${$iconSize};
    width: ${$iconSize};
  `}
`;

export const ButtonIcon = ({ children: Icon, size }: ButtonIconProps) => {
  const iconSize = `${getIconSize(size)}px`;

  return (
    <IconContainer $iconSize={iconSize}>
      <Icon size={getIconSize(size)} />
    </IconContainer>
  );
};
